module.exports = __webpack_public_path__ + "static/img/bl_hands_wr.4dfcb218.webp";